import Cookies from 'js-cookie';
import CONSTANTS from "../lib/constants"

export function removeLinkedinCookies() {
  Cookies.remove("linkdin-token", { path: '/', domain: CONSTANTS.DOMAIN });
  Cookies.remove("token", { path: '/', domain: CONSTANTS.DOMAIN });
}
